/**
 * theme scripts
 *
 * @author      Josh Cranwell <josh@werksmotorsport.com>
 * @copyright   The Sweet People
 * @version     1.0
 * @link        https://thesweetpeople.com
 * @since       5th January 2019
 */

// load jquery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// the new npm imports
require('bootstrap');
require('popper.js');
require('bootstrap-select');
require('slick-carousel');
require('select2');
require('lightgallery/lib/picturefill.min');
require('lightgallery');
require('lightgallery/modules/lg-thumbnail');
require('lightgallery/modules/lg-fullscreen');
require('lightgallery/lib/jquery.mousewheel.min');
require('datatables.net-dt');
require('datatables.net-bs4');
global.ScrollReveal = require('scrollreveal');
global.imagesLoaded = require('imagesloaded');
global.Cookies = require('js-cookie');
global.ClipboardJS = require('clipboard');

// jQuery on ready
jQuery(document).ready(function ($) {

    // our breakpoints
    const breakpoint = {
        // Small screen / phone
        sm: 576,
        // Medium screen / tablet
        md: 768,
        // Large screen / desktop
        lg: 992,
        // Extra large screen / wide desktop
        xl: 1200
    };


    // automatically show the popup
    $('#welcomePopup').modal('show');
    // welcome popup close and cookie
    $('#welcomePopupHide').click( function() {
        // set a cookie to say the popup has been seen
        Cookies.set('welcome_popup_seen', true, { expires: 365 });
        // close the popup
        $('#welcomePopup').modal('hide');
    });


    // automatically show the popup
    $('#rewardPopup').modal('show');
    // welcome popup close and cookie
    $('.reward-popup-hide').click( function() {
        // set a cookie to say the popup has been seen
        Cookies.set('reward_popup_seen', true, { expires: 365 });
        // close the popup
        $('#rewardPopup').modal('hide');
    });


    // open chatlio link
    $('.open-chatlio').click( function(e) {

        e.preventDefault();
        _chatlio.open();

    });


    // page anchor link
    $('.page-anchor-link').on('click', function(e) {

        // get the href from the clicked link
        let anchor = $(this).attr('href');

        // scroll too
        $('html,body').animate({ scrollTop: $(anchor).offset().top }, 1000);

        // prevent link defaults
        e.preventDefault();

    });


    // product archive row
    let $products = $('#product_archive > .row:first-child');

    // load more archive button
    $(document).on('click', '#load_more_products', function () {

        // our click button
        let $btn = $(this);

        // disable button
        $btn.html('<i class="fas fa-spinner fa-spin"></i> Loading products').prop('disabled', true);

        // set currents empty array
        let currentProducts = [];

        // loop thought trough all products in products in archive
        $('[data-product]', $products).each(function (key, el) {

            // current product push elem
            currentProducts.push($(el).data('product'));

        });

        // post current page again
        $.post('', {

            // pass this data
            excludeItems: currentProducts

        }, function (html) {

            // find all the products the parent div
            let $newProducts = $('#product_archive [data-product]', html).parent();

            //console.log($newProducts.length);

            // products append
            if ( $newProducts.length < PostsPerPage ) {

                // hide button
                $btn.hide();

            }

            // products append
            $products.append( $newProducts );

        })

        // products loaded
        .done(function() {

            // load images on the
            let imgLoad = imagesLoaded('#product_archive');

            imgLoad.on( 'progress', function( instance, image ) {
                $(image.img).parent('.img-thumbnail').addClass('img-loaded');
            }).on( 'done', function() {
                setTimeout(function() {
                    //$('#product_archive').find('.img-thumbnail > I').remove();
                }, 1000);
            });

            // re-enable button
            $btn.html('<i class="far fa-arrow-alt-down"></i> Load more products').prop('disabled', false);

        });

    });


    // footer fixed function
    let footerFixed = function() {

        // footer change objects
        let $footer             = $('#footer');
        let $wrapper            = $('BODY > .wrapper');
        // let $scrollerWrapper    = $('.scroller > .wrapper');

        // footer change vars
        let footerHeight        = $footer.outerHeight();

        // // footer changes
        // $scrollerWrapper.css('margin-bottom', footerHeight + 'px');
        $footer.removeClass('initial-load');

        $wrapper.css('padding-bottom', footerHeight + 'px');

    }; footerFixed(); // pixel on ready


    //btn copy tooltip
    $('.btn-copy').tooltip({
        trigger: 'click',
        placement: 'bottom'
    });

    // set tool function
    function setTooltip(btn, message) {
        $(btn).tooltip('hide')
            .attr('data-original-title', message)
            .tooltip('show');
    }

    // hide tool tip function
    function hideTooltip(btn) {
        setTimeout(function() {
            $(btn).tooltip('hide')
                .removeAttr('data-original-title')
        }, 1000);
    }

    // clipboard new class
    let clipboard = new ClipboardJS('.btn-copy');

    // clipboard success copied
    clipboard.on('success', function(e) {
        e.clearSelection();
        setTooltip(e.trigger, 'Copied!');
        hideTooltip(e.trigger);
    });

    // clipboard error copied
    clipboard.on('error', function(e) {
        e.clearSelection();
        setTooltip(e.trigger, 'Failed!');
        hideTooltip(e.trigger);
    });


    // product index sidebar open toggle
    $(document).on('click', '.remove-sample-item', function(e) {

        // get the item id number
        let removeItem = $(this).data('id');

        // remove item var
        removeItem = removeItem.toString();

        // get cookie data
        let myData = Cookies.get('sample_basket');

        // convert cookie string to data
        let myBasket = JSON.parse(myData);

        // remove our item
        let indexOf = myBasket.indexOf(removeItem);
        if (indexOf > -1) {
            myBasket.splice(indexOf, 1);
        }

        // turn the array back to string
        let myNewData = JSON.stringify(myBasket);

        // re set cookie with new serialized data
        Cookies.set('sample_basket',myNewData);

        // update the form hidden field
        $('#input_5_27').attr('value',myNewData);

        // remove the item html from the basket
        $('#basket_item_'+removeItem).remove();

        // if the data cost attr exists
        if( $(this).data('cost') ) {

            // update the high value charges
            update_highvalue_charge(removeItem, $(this).data('cost') );

        }

        // update the basket count
        $('#basket_count').html(Object.keys(myBasket).length);

        // prevent link defaults
        e.preventDefault();

    });

    // update the high value charge sample
    function update_highvalue_charge(product_id, costVal ) {

        let $chargeTableItems = $('#table_charge_items');
        let $chargeTableTotal = $('#table_charge_total');

        let items = $('TBODY TR', $chargeTableItems ).length;

        // console.log(items);

        if (items === 1) {

            $('#profile_highvalue_table').remove();

        } else {

            $('[data-id="' + product_id + '"]', $chargeTableItems ).remove();

            let oldValSub   = $('.highval-sub', $chargeTableTotal ).html();
            let newValSub   = oldValSub - costVal;
            let newValVat   = ( newValSub / 100 ) * 20;
            let newValTotal = newValSub + newValVat;

            $('.highval-sub',   $chargeTableTotal ).html(newValSub.toFixed(2));
            $('.highval-vat',   $chargeTableTotal ).html(newValVat.toFixed(2));
            $('.highval-total', $chargeTableTotal ).html(newValTotal.toFixed(2));

        }

    }



    // product index sidebar open toggle
    $('#grid_toggler').on('click', 'A', function() {

        // make changes to the clicked button in question
        $(this).addClass('active').siblings().removeClass('active');

        // if element clicked is equal to large
        if( $(this).data('size') === 'large' ) {

            // add grid size large class
            $('#product_archive').addClass('grid-large');

            // update the local storage item
            Cookies.set("grid_large", 1);

        } else {

            // remove grid size large class
            $('#product_archive').removeClass('grid-large');

            // remove the local storage item
            Cookies.remove("grid_large");

        }

    });


    // output scroll reveal if body classes ie-6>9 do not exist using regex check
    // if (!/(?:^|\s)ie\-[6-9](?:$|\s)/.test(document.body.className)) {
    //
    //     // scroll reveal profile listings
    //     window.sr = new ScrollReveal({ reset: false });
    //     sr.reveal('ARTICLE', {
    //         container: '.webapp-container',
    //         duration: 1000,
    //         distance: '60px'
    //     });
    //
    // }


    // To style all form selects except for the inline forms
    $('.dropdown-bs-convert SELECT').selectpicker();


    // sorting dropdown on change fire the form
    $('#product_sorting').on('change', ':input', function () {
        $('#product_sorting').submit();
    });


    // our product gallery
    let $oProductGallery = $('#product_gallery');

    let $oProductGallerySlider = $('.slider', $oProductGallery);

    let euRibbonShipping = $oProductGallerySlider.children('.ribbon-eu-shipping').detach();

    //console.log(euRibbonShipping);

    // slick product gallery
    $oProductGallerySlider.on('init', function(slick){

        // insert the eu shipping ribbon
        euRibbonShipping.appendTo($oProductGallerySlider);

        // rerun the footer fixed function
        footerFixed();

    }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        dots: true,
        asNavFor: '#product_gallery .slider-nav'
    });



    // slick nav manual button
    // $('.slider-nav a', $oProductGallery).on( "click", function(e) {
    //     e.preventDefault();
    //     slideIndex = $(this.parentNode).index();
    //     $('.slider', $oProductGallery).slick('slickGoTo', parseInt(slideIndex));
    // });

    let $oProductGallerySliderNav = $('.slider-nav', $oProductGallery);

    // slick product gallery nav
    $oProductGallerySliderNav.on('init', function() {
        footerFixed();
    }).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '#product_gallery .slider',
        dots: false,
        arrows: false,
        focusOnSelect: true
    });





    // slick front page carousel
    $('#frontpage_banner_carousel').on('init', function(slick){

        // if slick has no slides
        if(!$('.slick-track > *', slick.target).length) {

            // remove the frontpage banner element
            $(this).remove();

        }

        footerFixed();

    }).slick({
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        infinite: true,
        dots: false,
        speed: 1000,
        prevArrow: $('#frontpage_banner_carousel .slick-prev'),
        nextArrow: $('#frontpage_banner_carousel .slick-next'),
        swipeToSlide: true,
        adaptiveHeight: true,
        fade: false,
        responsive: [
            {
                breakpoint: breakpoint.sm,
                settings: {
                    fade: true
                }
            }
        ]
    });


    // slick frontpage product slider
    $('.frontpage-product-slider').slick({
        autoplay: false,
        draggable: true,
        infinite: false,
        dots: false,
        speed: 1000,
        arrows: true,
        prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
        nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: breakpoint.sm,
                settings: {
                    swipeToSlide: true,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: breakpoint.md,
                settings: {
                    swipeToSlide: false,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: breakpoint.lg,
                settings: {
                    swipeToSlide: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: breakpoint.xl,
                settings: {
                    swipeToSlide: false,
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            }
        ]
    }).on('reinit', function(){
        footerFixed();
        productSliderNavs();
    }).on('init', function(){
        footerFixed();
        productSliderNavs();
    });


    // slick frontpage product slider
    $('.frontpage-brands-slider').slick({
        autoplay: false,
        draggable: true,
        infinite: false,
        dots: false,
        speed: 1000,
        arrows: true,
        prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
        nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: breakpoint.sm,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: breakpoint.md,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: breakpoint.lg,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: breakpoint.xl,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6
                }
            }
        ]
    }).on('reinit', function(){
        footerFixed();
        productSliderNavs();
    }).on('init', function(){
        footerFixed();
        productSliderNavs();
    });


    // slick product recent
    $('#product_recent .slider').slick({
        autoplay: false,
        //autoplaySpeed: 2000,
        draggable: true,
        infinite: false,
        dots: false,
        speed: 1000,
        prevArrow: $('#product_recent .slick-prev'),
        nextArrow: $('#product_recent .slick-next'),
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        swipeToSlide: true,
        responsive: [
            // {
            //     breakpoint: breakpoint.sm,
            //     settings: {
            //         slidesToShow: 2,
            //         slidesToScroll: 2
            //     }
            // },
            {
                breakpoint: breakpoint.md,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: breakpoint.lg,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: breakpoint.xl,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }
        ]
    }).on('reinit', function(){
        footerFixed();
        productSliderNavs();
    }).on('init', function(){
        footerFixed();
        productSliderNavs();
    });


    // product gallery lightbox
    $('#product_gallery').lightGallery({
        selector: '.lightgallery',
        exThumbImage: 'data-thumbnail'
    });


    // page content lightgallery
    $('.page-content').lightGallery({
        selector: '.lightbox'
    });


    // product index sidebar open toggle
    $('.product-filters-toggler').bind('click',function(e) {

        // toggle page slide max height on off
        $('HTML').toggleClass('product-filters-open');

        // prevent link defaults
        e.preventDefault();

    });


    // footer fixed function
    let carouselReveal = function() {

        // carousel object
        let $carousel = $('#frontpage_banner_carousel');

        // add pre-loaded class to carousel
        $carousel.addClass('pre-loaded');

        // add loaded class to make height auto
        setTimeout(function(){

            // add loaded class after .5s
            $carousel.addClass('loaded');

        }, 500);

    };





    // home product carousel center arrows to img
    let productSliderNavs = function() {

        // product thumb
        let prodThumb = $('.frontpage-product-slider').find('.product-grid-item IMG').height();

        // slick navigation
        $('.slick-prev, .slick-next','.frontpage-product-slider').css({
            top: (prodThumb / 2) + 'px',
            visibility: 'visible'
        })

    }; productSliderNavs(); // pixel on ready


    // gform validation for username
    let gformLiveValidationUserName = function(elem) {

        // set out error class name
        let errorClass = 'validation-username-error';

        // username validation message for register forms
        $(elem).append('<div class="gfield_description d-none text-danger font-weight-bolder ' + errorClass + '">Your username is not a valid format.<br/>You can only use <abbr title="AbcDef123">alphanumeric characters</abbr>, <abbr title="_">underscores</abbr> and <abbr title=".">periods</abbr>.</div>');

        // username field validator helper for register forms
        $(elem).on('keyup', 'INPUT', function () {
            let userName = $(this).val();
            if (/^(?!.*__.*)(?!.*\.\..*)[a-z0-9_.]+$/.test(userName)) {
                $('.' + errorClass).addClass('d-none');
            } else {
                $('.' + errorClass).removeClass('d-none');
            }
        });

    };


    // gform validation for alpha numerical
    let gformLiveValidationLowercaseAlphaNu = function(elem) {

        // set out error class name
        let errorClass = 'validation-alphanu-error';

        // username validation message for register forms
        $(elem).append('<div class="gfield_description d-none text-danger font-weight-bolder ' + errorClass + '">You can only use <abbr title="abcdef123">lowercase alphanumeric characters</abbr>.');

        // username field validator helper for register forms
        $(elem).on('keyup', 'INPUT', function () {
            let userName = $(this).val();
            $(elem).find('.validation_message').remove();
            if (/^[a-z0-9]*$/.test(userName)) {
                $('.' + errorClass).addClass('d-none');
            } else {
                $('.' + errorClass).removeClass('d-none');
            }
        });

    };


    // gform prepend
    let gformInputPrepend = function( elem, content ) {

        // find element human
        let $input = $(elem).find('INPUT');

        // check if input group does not exist
        if (!$(elem + ' .input-group').length > 0) {

            // wrap the input with prepend and input group
            $input.wrap('<div class="input-group"></div>').before(
                '<div class="input-group-prepend">\n' +
                '<span class="input-group-text">' + content + '</span>\n' +
                '</div>\n');

        } else {

            // if prepend element does not exist then add it
            if (!$(elem + ' .input-group-prepend').length > 0) {

                // prepend the prepend span
                $(elem).find('.input-group').prepend('<div class="input-group-prepend">\n' +
                    '<span class="input-group-text">' + content + '</span>\n' +
                    '</div>\n');

            }

        }

    };


    // gform prepend
    let gformInputAppend = function( elem, content ) {

        // find element human
        let $input = $(elem).find('INPUT');

        // check if input group does not exist
        if (!$(elem + ' .input-group').length > 0) {

            // wrap the input with the complete .input-group
            $input.wrap('<div class="input-group"></div>')
                .after('<div class="input-group-append">\n' +
                '<span class="input-group-text">' + content + '</span>\n' +
                '</div>\n');

        } else {

            // if append element does not exist then add it
            if (!$(elem + ' .input-group-append').length > 0) {

                // append the append span
                $(elem).find('.input-group').append('<div class="input-group-append">\n' +
                    '<span class="input-group-text">' + content + '</span>\n' +
                    '</div>\n');

            }

        }

    };


    // load images on the
    let imgLoad = imagesLoaded('BODY');
    imgLoad.on('progress', function( instance, image ) {
        $(image.img).parent('.img-thumbnail').addClass('img-loaded');
    }).on('done', function() {
        setTimeout(function() {
            $('#product_archive').find('.img-thumbnail > I').remove();
            productSliderNavs();
        }, 1000);
    });


    // common questions filter
    $('.common-questions').on('keyup', 'INPUT', function (e) {

        // get our elements
        let $widget = $(e.delegateTarget);
        let inputVal = $(this).val().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        let $list = $('UL', $widget);
        let itemsVisible = 0;

        // return false if we dont have a list
        if($list.length < 1) return false;

        // loop through each item in the list
        $("LI:not('.filter-no-results')", $list).each(function (key, item) {

            // store our text
            let text = $(this).text();

            // check if the item is visible
            let itemVisible = text.match(new RegExp(inputVal, 'i'));

            // remove classes
            $(item).removeClass('filter-visible filter-hidden');

            // check if we have a match
            $(item).addClass('filter-' + (itemVisible ? 'visible' : 'hidden'));

            // if item is visible, increment our count
            if(itemVisible) ++itemsVisible;

        });

        // check if we have no items visible
        if(itemsVisible === 0) {
            $('LI.filter-no-results', $list).show();
        } else {
            $('LI.filter-no-results', $list).hide();
        }

    });


    // reveal password link
    $('.reveal-password').each(function () {

        // on click
        $(this).on("click", function(e) {

            // prevent link default
            e.preventDefault();

            // reset everything back to
            $('.reveal-password').html('Reveal password');

            // get this password
            let password = $(this).data('password');

            // shot the password
            $(this).html(password);

        });

    });


    // window resize
    $(window).on('resize', function () {

        // resize pixel stuff
        footerFixed();
        productSliderNavs();

    }).trigger('resize');

    // scroll functions
    $(window).scroll(function() {


        // add/remove class to nav bar when scrolling to hide/show
        let windowHeight    = $(window).outerHeight();
        let scrollHeight    = $('BODY > .wrapper').outerHeight();
        let scrollPoint     = $(this).scrollTop();

        if (scrollPoint >= ( ( scrollHeight - windowHeight ) - 5 ) ) {
            $('.chatlio-widget').fadeOut(200).addClass('chatlio-hide');
        } else {
            $('.chatlio-widget').fadeIn(0).removeClass('chatlio-hide');
        }


        // anchor card sticky
        let headerHeight    = $('#header').outerHeight();
        let pageHeadHeight  = $('#page_header').outerHeight();

        if (scrollPoint >= ( headerHeight + pageHeadHeight ) ) {
            $('#anchor_card').addClass('sticky');
        } else {
            $('#anchor_card').removeClass('sticky');
        }

        //console.log('products');

        if($(document).find('BODY').hasClass('router-products')) {

            if($('#load_more_products')) {

                let reload_point = $('#load_more_products').offset();

                // console.log(reload_point.top);
                // console.log(windowHeight);
                // console.log(scrollHeight);

                if(scrollHeight = scrollPoint) {

                    $('#load_more_products').click();

                }


            }



        }

    });

    // code to trigger hacks on ajax gravity form render
    $(document).on('gform_post_render', function(event, form_id){

        // remove weird introduction of inline display none
        //$('.gform_wrapper').removeAttr('style');

        // turn auto complete off for some browsers on gf
        $('FORM, INPUT:not([type="password"]), SELECT','.gform_wrapper').attr('autocomplete','off');

        // change the select
        $('.select-companies SELECT').select2({
            placeholder: 'Select a company'
        });

        // remove the validation error if the decide to add a new company mid reg
        $('.add-new-company').on('change', 'input', function () {
            $('.gform_wrapper').removeClass('gform_validation_error');
            $('.validation_error').remove();
        });

        // address input/select vars
        let sAddressInputR  = '.ginput_container_address INPUT[aria-required="true"]';
        let sAddressSelectR = '.ginput_container_address SELECT[aria-required="true"]';

        // address field bootstrap validation hack
        $(sAddressInputR + ', ' + sAddressSelectR,'.gform_validation_error').each(function () {
            // check if value exists
            if( $(this).val() ) {
                // add the aria invalid false attribute
                $(this).attr('aria-invalid','false');
            }
        });

        // register form
        if(form_id === 1) {

            // form validation user name
            gformLiveValidationUserName('#field_1_16, #field_2_24');

        }

        // admin register form
        if(form_id === 2) {

            // form validation user name
            gformLiveValidationUserName('#field_1_16, #field_2_24');

        }

        /*

        // edit profile
        if(form_id == 3) { }

        // sample request
        if(form_id == 5) { }

        // company info
        if(form_id == 6) { }

        // send us a message
        if(form_id == 7) { }

        // coming soon
        if(form_id == 8) { }

        // website issues
        if(form_id == 9) { }

        */

        // white label creator
        if(form_id === 10) {

            // alpha numerical validation
            gformLiveValidationLowercaseAlphaNu('#field_10_12');

            // prepend domain field http
            gformInputPrepend('#field_10_12','https://');

            // append domain field sweet.space
            gformInputAppend('#field_10_12','.' + $('BODY').data('sweetspace'));

            // append unit price mark up
            gformInputAppend('#field_10_16','%');

            // append unit price mark up
            gformInputAppend('#field_10_17','%');

            // append shipping mark up
            gformInputAppend('#field_10_19','%');

            // append shipping mark up
            gformInputAppend('#field_10_20','%');

            // append origination mark up
            gformInputPrepend('#field_10_21','£');

            // append origination mark up
            //gformInputAppend('#field_10_22','%');

            // trigger markup
            $('.field-markup [type="number"]').trigger('input');

        }

        // white label settings editor
        if(form_id === 12) {

            // alpha numerical validation
            gformLiveValidationLowercaseAlphaNu('#field_12_12');

            // prepend domain field http
            gformInputPrepend('#field_12_12','https://');

            // append domain field sweet.space
            gformInputAppend('#field_12_12','.' + $('BODY').data('sweetspace'));

            // append unit price mark up
            gformInputAppend('#field_12_16','%');

            // append unit price mark up
            gformInputAppend('#field_12_18','%');

            // append shipping mark up
            gformInputAppend('#field_12_21','%');

            // append shipping mark up
            gformInputAppend('#field_12_22','%');

            // append origination mark up
            gformInputPrepend('#field_12_23','£');

            // append origination mark up
            //gformInputAppend('#field_12_24','%');


            // trigger markup
            $('.field-markup [type="number"]').trigger('input');

        }

        // white label theme editor
        if(form_id === 13) {

            // prepend all the iris forms
            $('.iris-wrapper').each(function() {

                // get the id
                let field = '#' + $(this).attr('id');

                // prepend color picker
                gformInputPrepend(field,'');

            });

            // append px max width header logo
            gformInputAppend('#field_13_60','px');

            // append px max height header logo
            gformInputAppend('#field_13_61','px');

            // append px max width login logo
            gformInputAppend('#field_13_62','px');

            // append px max height login logo
            gformInputAppend('#field_13_63','px');

        }

        // white label contact settings
        if(form_id === 16) {

            // prepend tel icon
            gformInputPrepend('#field_16_17','<i class="far fa-phone fa-flip-horizontal"></i>');

            // prepend email icon
            gformInputPrepend('#field_16_18','<i class="far fa-envelope"></i>');

        }

        // fix the footer
        footerFixed();

    });


    // code to trigger stuff when forms have submitted
    $(document).on('gform_confirmation_loaded', function(event, form_id){

        // run code for sample request form for submit id 5
        if(form_id === 5) {

            // remove the sample basket
            $('#profile_sample_basket').remove();

        }

    });


    // window on load
    $(window).on('load', function() {

        // pixel stuff
        footerFixed();
        productSliderNavs();
        carouselReveal();

        // render white label table using data tables
        $('#table_white_label').DataTable({
            //fixedHeader: true,
            //paging: false,
            order: [[4, "desc"]],
            //dom: "<'row'<'col-xl-7 col-lg-6 tab-title'l><'col-xl-5 col-lg-6 mb-lg-0 mb-3'<'row'<'col-lg-5 col-md-6 mb-md-0 mb-2'f><'col-lg-7 col-md-6 wl-create-btn'>>>><'row'<'col-sm-12'<'table-responsive't>>><'data-table-footer'<'row'<'col-md-6'i><'col-md-6'p>>>",
            dom: "<'d-xl-flex justify-content-xl-between'<'tab-title'l><<'d-sm-flex justify-content-sm-start'<'mr-sm-3 mb-sm-3 mb-3'f><'mb-sm-3 mb-3 wl-create-btn'>>>><'row'<'col-sm-12'<'table-responsive't>>><'data-table-footer'<'row'<'col-md-6'i><'col-md-6'p>>>",
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Filter websites"
            },
            pageLength: 100,
            bLengthChange: false,
            initComplete: function () { // params settings, json

                // move the page title to the data tables dom
                $('.page-title','#nav-white-label').prependTo('#nav-white-label .tab-title');

                // move the page title to the data tables dom
                $('#addSiteButton','#nav-white-label').prependTo('#nav-white-label .wl-create-btn');

                // wrap the table in a wrapper to fix position in full screen mode
                //$('.data-table-footer',$WhiteLabelTab).wrap('<div class="data-table-footer-wrapper"></div>');

                $('#table_white_label_wrapper').removeClass('form-inline');

                $('.form-control','#table_white_label_filter').removeClass('form-control-sm');

            }
        });

    });


    // calculators types array
    let prices = ['unit','shipping']; // origination

    // pricing markup/margin
    prices.forEach(marginMarkupInputs);

    // markup margin calculator each loop
    function marginMarkupInputs(type) {

        // unit margin live markup calculator
        $(document).on('input', '.field-margin-' + type + ' [type="number"]', function(e) {

            // this value
            let iVal = parseFloat($(this).val());

            // if our val is less than 0 or equal too
            if (iVal <= 0) {

                // reset our var to 0
                iVal = 0;

                // reset the value to 50
                $(this).val(iVal).trigger('change');

            }

            // if our val is greater than 50 or equal too
            else if (iVal >= 50) {

                // reset our var to 50
                iVal = 50;

                // reset the value to 50
                $(this).val(iVal).trigger('change');

            }

            // calculate the margin
            let iMargin = 1 / (1 - (iVal / 100));

            // margin percentage
            let iMarkup = (iMargin - 1) * 100;

            // set our value to fix 2 decimal points
            iMarkup = iMarkup.toFixed(2);

            // set the markup field with the calculated margin
            $('.field-markup-' + type + ' [type="number"]').val(iMarkup).trigger('change');

        });

        // unit margin live markup calculator
        $(document).on('input', '.field-markup-' + type + ' [type="number"]', function() {

            // this value
            let iVal = parseFloat($(this).val());

            // if our val is less than 0 or equal too
            if(iVal <= 0) {

                // reset our let to 0
                iVal = 0;

                // reset the value to 50
                $(this).val(iVal).trigger('change');

            }

            // if our val is greater than 50 or equal too
            else if(iVal >= 100) {

                // reset our let to 50
                iVal = 100;

                // reset the value to 50
                $(this).val(iVal).trigger('change');

            }

            // calculate the margin
            let iMarkup = ( iVal / 100 ) + 1;

            // margin percentage
            let iMargin = 100 - ( ( 1 / iMarkup ) * 100 );

            // set our value to fix 2 decimal points
            iMargin = iMargin.toFixed(2);

            // set the markup field with the calculated margin
            $('.field-margin-' + type + ' [type="number"]').val( iMargin ).trigger('change');

        });

    }

    // generate email signature code
    new ClipboardJS('#generate-email-code', {

        // text copy function
        text: function(trigger) {

            // set elem (not sure we need this)
            let elem = $(trigger).data('clipboard-element');

            // get signature html code
            let signature = $('#email-signature-preview');

            // opening header html 4
            let head = '<!doctype html public "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">\n' +
                '<html>\n' +
                '<head>\n' +
                '  <title></title>\n' +
                '</head>\n' +
                '<body>';

            // closing footer html 4
            let footer = '</body>\n' +
                '</html>';

            // html head
            let html = head;
                html += signature[0].innerHTML;
                html += footer;

            // finally return html 4
            return html;

        },

        success: function(e) {

            // console info
            console.info('Action:', e.action);
            console.info('Text:', e.text);
            console.info('Trigger:', e.trigger);

            // consolesuccess
            console.log('success');

        }

    });

    // mac isolate signature code for copy
    $(this).on('click','#mac-email-code', function(e) {

        // prevent link default
        e.preventDefault();

        // get html content for the email signature container
        let preview = $('#email-signature-preview').html();

        // replace with html
        $('html').html(preview);

    });

    // eu switch
    $(this).on('input','.custom-eu-switch-input', function(e) {

        // prevent link default
        e.preventDefault();

        // if switch is checked
        if(this.checked) {

            // set eu shipping cookie
            Cookies.set('eu_shipping', true, { expires: 365 });

        } else {

            // remove eu shipping cookie
            Cookies.remove('eu_shipping');

        }

        location.reload();

    });

    // exit eu shipping
    $(this).on('click','.exit-eu-shipping', function(e) {

        // prevent link default
        e.preventDefault();

        // slide up notification
        $('#notification-eu').slideUp();

        // remove eu shipping cookie
        Cookies.remove('eu_shipping');

        // reload location
        location.reload();

    });

    // // register form populate gdpr hidden field
    // $('#field_1_18',this).on('change','INPUT', function(e) {
    //
    //     // gdpr checked array
    //     let gdpr = [];
    //
    //     // loop though all the inputs
    //     $('INPUT','#field_1_18').each(function(i) {
    //
    //         // if is checked
    //         if($(this).is(':checked')) {
    //
    //             // push value to array
    //             gdpr.push($(this).val());
    //
    //         }
    //
    //     });
    //
    //     // jquery post ajax call
    //     $.ajax({
    //         cache: false,
    //         timeout: 300000, // 5 hours
    //         url: ajaxurl,
    //         method: 'POST',
    //         data: {
    //             action: 'serialize_array',
    //             data: gdpr
    //         },
    //         // success response
    //         success: function (response) {
    //
    //             // populate our hidden field
    //             $('#input_1_29').val(response.data);
    //
    //         }
    //     });
    //
    // });

});